function isASTHtmlNode(node) {
  return node.nodeType === "html";
}

export { isASTHtmlNode };
//# sourceMappingURL=core.html.js.map
